import React from "react";
import PropTypes from "prop-types";
import styles from "./Objective.css";

const Objective = ({ summary }) => (
  <div className={styles.Objective}>
    <div className={styles.ObjectiveHeader}>
      <h2>Summary</h2>
      <div className={styles.Summary}>
        <p>{summary}</p>
      </div>
    </div>
  </div>
);

Objective.propTypes = {
  summary: PropTypes.string.isRequired
};

export default Objective;



// WEBPACK FOOTER //
// ./src/containers/ResumeBox/Resume/Objective/Objective.js